import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./productcard.module.css";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { getProductbyId } from "../../../src/apis/product";
import { formatPrice } from "../../utils/product";

const ProductCard = ({ productId }) => {
    const { t } = useTranslation();
    const [cookies] = useCookies(["access_token"]);
    const [product, setProduct] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProductDetails = async () => {
            try {
                const token = cookies["access_token"];
                const result = await getProductbyId(productId, token);
                setProduct(result.data);
                console.log(result.data)
            } catch (error) {
                console.error("Failed to fetch product details:", error);
            }
        };

        fetchProductDetails();
    }, [productId, cookies]);

    const handleNavigateToDetail = () => {
        navigate(`/product/${productId}`);
    };

    if (!product) {
        return <div>Loading...</div>;
    }

    // Extract the first imageURL and price from product metadata
    const imageURL = product.images?.[0]?.imageURL || "";
    const productMetadata = product.productMetadata;
    const price =
        productMetadata && productMetadata.length > 0
            ? productMetadata[0].price
            : "N/A";

    return (
        <div className={styles.container} onClick={handleNavigateToDetail}>
            <div
                className={styles.card_bg}
                style={{ backgroundImage: `url(${imageURL})` }}
            ></div>
            <div className={styles.card_bg_overlay}></div>
            <div className={styles.name}>{product.name}</div>
            <div className={styles.price}>{formatPrice(price)}</div>
            <button className={styles.butt} onClick={handleNavigateToDetail}>
                {t("view_details")}
            </button>
        </div>
    );
};
export default ProductCard;
